import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import { scrollToTop } from '@utils/usefulFuncs';
import { DocumentDownloadTool } from '@containers/DigitalAnalyst/components/DocumentDownloadTool';
import { AI_TOOLS, DOCUMENT_TEMPLATE_MODE_IDS } from '@constants';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const modeId = DOCUMENT_TEMPLATE_MODE_IDS.peer_benchmarking_template;
const tool = AI_TOOLS.PEER_BENCHMARKING_TEMPLATE;

function PeerBenchmarkingPage() {
  const navigate = useNavigate();

  const onGoBack = () => navigate(ROUTES.home);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <DocumentDownloadTool onGoBack={onGoBack} modeId={modeId} tool={tool} />
      </Body>
    </PageWrapper>
  );
}

export default PeerBenchmarkingPage;
